import './LayoutPreview.scss'
import React from 'react'
import classnames from 'classnames'

const AppearancePreview = ({ display, type, pos, children, colorStyle }) => {
  const className = classnames('Layout', {
    'Layout-open': display !== 'launcher',
    'Layout-expand': display !== 'launcher',
    'Layout-right': pos !== 'left',
    'Layout-left': pos === 'left',
    [`Launcher-${type}`]: display === 'launcher'
  })
  return (
    <div className={className} style={colorStyle}>
      {children}
    </div>
  )
}

export default AppearancePreview



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/LayoutPreview.js